module.exports = __webpack_public_path__ + "static/media/Recovery__Illustration.7ed8d450.png";